import { ProCard, ProForm } from "@ant-design/pro-components"
import { useState } from "react"
import api from "../../api"
import { AntPageContainer } from "../../shared/components/AntPageContainer"
import { ErrorMessage } from "../../shared/components/ErrorMessage"
import { RechargePlansFormFields } from "../components/recharge-plans-form-fields"
import { message } from 'antd';
import { useNavigate } from "react-router-dom"
import { CreateRechargePlanRequest } from "../../api/recharge-plans"

export const CreateRechargePlan = () => {
    const [error, setError] = useState<any>(null);
    const navigate = useNavigate();


    return <AntPageContainer>
        <ProCard bordered>
            <ProForm<CreateRechargePlanRequest>
                grid
                colProps={{ span: 12 }}
                onFinish={async (data) => {

                    try {
                        await api.rechargePlans.create(data);
                        message.success("Success")
                        navigate("/admin/recharge-plans");
                    } catch (e) {
                        setError(e);
                    }
                }}
            >
                <RechargePlansFormFields />
            </ProForm>
            {
                error && <ErrorMessage error={error} />
            }
        </ProCard>
    </AntPageContainer>
}